import { Close as CloseIcon } from '@mui/icons-material';
import { Box, IconButton, Stack, Typography, alpha } from '@mui/material';
import { useState } from 'react';

import MainCard from '../Card/MainCard';
import { ALERT_ICONS, AlertIconKey } from './constants';

export interface OpsAlertCardProps {
  title?: string | null;
  content: string;
  icon?: AlertIconKey | null;
  color?: string | null;
}

const OpsAlertCard: React.FC<OpsAlertCardProps> = ({
  title,
  content,
  icon,
  color,
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const Icon = icon && ALERT_ICONS[icon]?.icon;

  if (!isVisible) {
    return null;
  }

  return (
    <MainCard
      border={false}
      sx={{
        transition: 'all 0.3s ease-in-out',
        background: alpha(color ?? '#1677ff', 0.1),
        borderRadius: 4,
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <IconButton
        size="small"
        onClick={() => setIsVisible(false)}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          borderRadius: 4,
          color: 'text.secondary',
          zIndex: 1,
          '&:hover': {
            bgcolor: 'white',
          },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
      <Stack direction="row" spacing={2} alignItems="flex-start">
        {Icon && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              color: color ?? '#1677ff',
            }}
          >
            <Icon sx={{ fontSize: 32 }} />
          </Box>
        )}
        <Box sx={{ pr: 3, flex: 1 }}>
          {title && (
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              {title}
            </Typography>
          )}
          <Typography variant="body1">{content}</Typography>
        </Box>
      </Stack>
    </MainCard>
  );
};

export default OpsAlertCard;
